import { Button, Container } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export const CTA: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      className="md:py-20 py-12 text-center bg-blue-50"
    >
      <Container className="flex flex-col md:gap-6 gap-2 md:mt-20">
        <motion.h2 className="z-50 text-5xl text-[#0101ff] font-bold" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: "easeOut" }} viewport={{ once: true }}>
          Get Your Diamedic Card Today
        </motion.h2>
        <motion.h3 className="md:mt-2 mt-4 text-black font-semibold text-xl md:text-xl" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }} viewport={{ once: true }}>
          A Diamedic card is a one-time purchase (with free shipping). Once
          acquired, there are no recurring fees or additional costs.
        </motion.h3>

        <motion.div
          className="mt-12 mx-4 grid grid-cols-1 md:grid-cols-2 gap-12"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", staggerChildren: 0.2 }}
          viewport={{ once: true }}
        >
          <motion.div
            className="p-8 bg-[#3366FF] rounded-2xl shadow-xl flex flex-col gap-6"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <div className="text-center">
              <h2 className="text-white text-3xl md:text-4xl font-extrabold mb-3 text-start">
                Your Diamedic Card
              </h2>
              <p className="text-white text-2xl md:text-3xl font-semibold text-start">
                £14.99
              </p>

            </div>
            <div className="space-y-3 text-white text-md text-start">
              <p>
                Designed for diabetics, providing comprehensive medical details including, but not limited to:
              </p>
              <ul className="space-y-2">
                <li className="flex items-center text-start gap-2">
                  <span className="text-lg">✔</span>
                  <strong>Insulin types and dosages</strong>
                </li>
                <li className="flex items-center text-start gap-2">
                  <span className="text-lg">✔</span>
                  <strong>Emergency protocols</strong>
                </li>
                <li className="flex items-center text-start gap-2">
                  <span className="text-lg">✔</span>
                  <strong>Diabetic-specific information</strong>
                </li>
              </ul>
            </div>
            <span className="text-white text-xs italic opacity-80">
              * Internet connection required to update information
            </span>
            <div className="mt-4">
              <Button
                aria-label="Get Started"
                disabled
                onClick={() => navigate("/checkout")}
                sx={{
                  background: "linear-gradient(to right, #FFD700, #FFA500)",
                  color: "#000",
                  "&:hover": {
                    background: "linear-gradient(to right, #FFA500, #FF8C00)",
                    transform: "scale(1.05)",
                  },
                }}
                variant="contained"
                className="w-full py-3 rounded-full shadow-md"
              >
                <span className="text-md font-semibold">Under Maintenance</span>
              </Button>
            </div>
          </motion.div>
          <motion.div
            className="md:h-full h-[526px] bg-green-300 text-black rounded-lg shadow-xl flex flex-col justify-center items-center relative"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <div className="absolute top-3 right-3 bg-black text-white px-4 py-1 rounded-full text-sm font-semibold">
              Coming Soon
            </div>
            <p className="md:font-normal font-bold text-2xl md:text-3xl text-center md:px-0 px-3">
              Your Diamedic Wristband
            </p>
          </motion.div>
        </motion.div>
        <motion.div
          className="mt-20 flex flex-col items-center justify-center text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
          viewport={{ once: true }}
        >
          <h3 className="text-xl md:text-2xl font-semibold mb-2 text-black">
            Not ready to buy just yet?
          </h3>
          <p className="text-md md:text-lg mb-4 text-gray-700 max-w-xl">
            You can still be part of the community! Join our Discord server to chat with others, ask questions, and follow Diamedic's progress.
          </p>
          <Button
            href="https://discord.gg/qV3BTjKMv3"
            target="_blank"
            size="large"
            rel="noopener noreferrer"
            sx={{
              background: "#5865F2",
              color: "#fff",
              "&:hover": {
                background: "#4752C4",
                transform: "scale(1.05)",
              },
            }}
            variant="contained"
            className="rounded-full px-6 py-3 font-semibold shadow-md"
          >

            Join Our Discord
          </Button>
        </motion.div>

      </Container>
    </div>
  );
};
